// Cloudinary Configuration
export const CLOUDINARY_CONFIG = {
  cloudName: 'dbkn2kqgn',
  uploadPreset: 'clickorico_products', // À créer dans Cloudinary (voir instructions ci-dessous)
  apiKey: '914956753485937'
};

// Instructions pour créer l'upload preset:
// 1. Va sur https://console.cloudinary.com/settings/upload
// 2. Scroll jusqu'à "Upload presets"
// 3. Clique sur "Add upload preset"
// 4. Nom: "clickorico_products"
// 5. Signing Mode: "Unsigned"
// 6. Folder: "products"
// 7. Save

